import { createNamespacedHelpers } from 'vuex-composition-helpers';
const { useState } = createNamespacedHelpers('offer');
export const useOffer = () => {
    const { currentOffer } = useState(['currentOffer']);
    return {
        currentOffer,
    };
};
